import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../services/authService';
import { useAuth } from '../context/AuthContext';
import { useState, useEffect } from 'react';

const Navbar = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    // Check for saved theme preference or default to light
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const shouldBeDark = savedTheme === 'dark' || (!savedTheme && prefersDark);
    
    setIsDark(shouldBeDark);
    if (shouldBeDark) {
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    const newDarkMode = !isDark;
    setIsDark(newDarkMode);
    
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  const handleLogout = async () => {
    await logoutUser();
    navigate('/login');
  };

  const stats = userData?.stats || { wins: 0, losses: 0, draws: 0 };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        {/* Logo - Left */}
        <div className="flex items-center gap-3">
          <span className="text-3xl">♔</span>
          <span className="navbar-logo">
            LMC <span className="font-bold">Arena</span>
          </span>
        </div>

        {/* Stats Badge - Center */}
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <div className="bg-surface dark:bg-dark-surface border-2 border-border dark:border-dark-border px-6 py-2 flex items-center gap-6">
            <div className="text-center">
              <div className="text-accent dark:text-dark-accent font-bold text-lg">{stats.wins}</div>
              <div className="text-text-tertiary dark:text-dark-text-tertiary text-xs font-medium">Wins</div>
            </div>
            <div className="w-px h-8 bg-border dark:bg-dark-border"></div>
            <div className="text-center">
              <div className="text-accent dark:text-dark-accent font-bold text-lg">{stats.losses}</div>
              <div className="text-text-tertiary dark:text-dark-text-tertiary text-xs font-medium">Losses</div>
            </div>
            <div className="w-px h-8 bg-border dark:bg-dark-border"></div>
            <div className="text-center">
              <div className="text-text-secondary dark:text-dark-text-secondary font-bold text-lg">{stats.draws}</div>
              <div className="text-text-tertiary dark:text-dark-text-tertiary text-xs font-medium">Draws</div>
            </div>
          </div>
        </div>

        {/* User Controls - Right */}
        <div className="flex items-center gap-6">

          {/* Username */}
          <div className="text-text-primary dark:text-dark-text-primary font-medium text-base">
            {userData?.username || 'Player'}
          </div>

          {/* Dark Mode Toggle */}
          <button 
            onClick={toggleDarkMode}
            className="w-11 h-11 border-2 border-border-heavy dark:border-dark-border-heavy bg-background dark:bg-dark-surface flex items-center justify-center hover:bg-hover-bg dark:hover:bg-dark-hover-bg transition-all duration-150"
            aria-label="Toggle dark mode"
          >
            {isDark ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-accent dark:text-dark-accent">
                <circle cx="12" cy="12" r="5"/>
                <line x1="12" y1="1" x2="12" y2="3"/>
                <line x1="12" y1="21" x2="12" y2="23"/>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                <line x1="1" y1="12" x2="3" y2="12"/>
                <line x1="21" y1="12" x2="23" y2="12"/>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-accent dark:text-dark-accent">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
              </svg>
            )}
          </button>

          {/* Logout */}
          <button 
            onClick={handleLogout}
            className="btn btn-primary text-sm"
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
